export default "__VITE_ASSET__be1f040e__"